import { DynamicSettings } from "Components/admin/DynamicSettings";
import { iconButton } from "Components/iconButton";
import i18next from "i18next";
import { html } from "lit-html";
import { USA_CULTURE_CODE, BRASILIAN_CULTURE_CODE } from "Services/constants";

export interface Props {
	culture: string;
	dynamicSettings: DynamicSettings;
}

export const useInsuranceTab = (props: Props) => {
	const showInsuranceTab = () =>
		props.dynamicSettings.DynamicInsuranceTabSettings.find(
			(s) => s.Culture.toLocaleLowerCase() === props.culture.toLocaleLowerCase()
		)?.IsActive;

	const getInsuranceTabUrl = () =>
		props.dynamicSettings.DynamicInsuranceTabSettings.find(
			(s) => s.Culture.toLocaleLowerCase() === props.culture.toLocaleLowerCase()
		)?.Url;

	const handleInsuranceButtonClick = () => {
		window.open(getInsuranceTabUrl(), "_blank");
	};

	const insuranceButton = iconButton({
		isAction: true,
		icon: html`<i class="jsh-circle-chevron-right1 text-base"></i>`,
		label: i18next.t("search-box-insurance-button"),
		onClick: handleInsuranceButtonClick,
	});

	const insuranceTabButtonTemplate = () => {
		const image =
			props.culture.toLocaleLowerCase() === USA_CULTURE_CODE
				? "chubb-logo-en.svg"
				: props.culture.toLocaleLowerCase() === BRASILIAN_CULTURE_CODE
				? "chubb-logo-pt.svg"
				: "chubb-logo-es.svg";

		return html`
			<div class="dg-insurance-btn-container">
				${insuranceButton.htmlTemplate()}
				<img class="dg-insurance-logo" src=${`/images/header/${image}`} />
			</div>
		`;
	};

	const htmlTemplate = () =>
		showInsuranceTab()
			? html` <div class="h-full w-full px-4 py-6">${insuranceTabButtonTemplate()}</div> `
			: html``;

	return { htmlTemplate };
};
